import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const FolderFileTickIcon: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M7.92114 3.01367H9.79614C10.4638 3.01367 11.1045 3.334 11.5061 3.86914H11.5071L12.3625 5.00684V5.00781C12.7661 5.54321 13.4049 5.86068 14.0745 5.86328H16.7268C18.3879 5.86328 19.5039 6.28927 20.2161 7.0752C20.8926 7.82184 21.2823 8.97757 21.3284 10.6562L21.3333 10.999L21.3059 15.6533V15.6562C21.3059 17.3815 20.7932 18.7004 19.9065 19.5869C19.0197 20.4734 17.6998 20.9863 15.9729 20.9863H8.67798C6.94741 20.9863 5.62544 20.4729 4.73657 19.5859C3.84782 18.699 3.33325 17.3799 3.33325 15.6533V8.3418C3.33325 6.43935 3.73883 5.12374 4.46997 4.28613C5.14437 3.51365 6.16383 3.07082 7.62329 3.01855L7.92114 3.01367ZM16.2981 10.2578C15.8085 9.76992 15.0192 9.77179 14.5315 10.2578L14.5305 10.2588L11.2747 13.5166L10.135 12.377C9.64675 11.8887 8.85472 11.8887 8.36646 12.377C7.87822 12.8652 7.8782 13.6563 8.36646 14.1445L10.3909 16.1689L10.3918 16.1709C10.6262 16.4035 10.9443 16.5352 11.2756 16.5352C11.6075 16.5351 11.9237 16.4029 12.1575 16.1709L12.1584 16.1689L16.2991 12.0264C16.7873 11.5381 16.7873 10.746 16.2991 10.2578H16.2981Z"
        fill={props.fill || "currentColor" || "#3064C0"}
        stroke="#3064C0"
      />
    </svg>
  );
};

export default FolderFileTickIcon;
